$(document).on('render:papers', () => {
  document.querySelector('.back_btn').style.display = 'flex'

  const bigImg = document.querySelector('.bigImg')
  const g_phont = document.querySelector('.g_phont')
  const g_right = document.querySelector('.g_right')

  const bindLightbox = (selector) => {
    document.querySelectorAll(selector).forEach((item) => {
      item.onclick = function () {
        g_phont.style.display = 'block'
        bigImg.src = item.src
        document.body.style.overflow = 'hidden'
      }
    })
  }

  const closeLightbox = () => {
    g_phont.style.display = 'none'
    document.body.style.overflow = ''
  }

  if (g_right) {
    g_right.onclick = closeLightbox
  }

  if ($('body').attr('data-action') === 'index') {
    bindLightbox('.papers_patent_list .patent_img img')
  } else {
    bindLightbox('.patent_img img')
    bindLightbox('.papers_cert_grid .patent_img img')
  }
})
